module.exports = __webpack_public_path__ + "static/img/22-红英小学(冷泉学部)1.9bea4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/22-红英小学(冷泉学部)1.png
// module id = 49M/
// module chunks = 0